import React from 'react';
import { PaneModal } from './PaneModal';
import { useTranslation } from 'react-i18next';
import { Button } from '@plecto/ui';
import { PaneButtons, PaneContent } from './PaneModal.styled';

type ConfirmCloseUnsavedChangesModalProps = {
    message: string;
    onDiscard: () => void;
    onCancel: () => void;
}

export function ConfirmCloseUnsavedChangesModal({
	message, onDiscard, onCancel
}: ConfirmCloseUnsavedChangesModalProps) {
	const { t } = useTranslation();
	return <PaneModal
		title={t('Discard unsaved changes?')}
		onClose={onCancel}
		forceTop
	>
		<PaneContent>
			{message}
		</PaneContent>
		<PaneButtons>
			<Button label={t('Cancel')} variant={'secondary'} onClick={onCancel} />
			<Button label={t('Discard changes')} variant={'danger'} onClick={onDiscard} />
		</PaneButtons>
	</PaneModal>;
}
